import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz40 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel41'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel39'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Find missing Row in Excel</h1>
    
    <div class="text">
        <p>We are given an excel sheet which contains integers from 1 to 50, including both. However, the numbers are in
            a jumbled form and there is 1 integer missing. You have to write a code to identify the missing integer.
            Only the logic is required.</p>
        <p>&nbsp;<br/>&nbsp;<br/>&nbsp;</p>
        <div class="containers">
        <p><strong><br/>Solution:</strong><br/>We know that the sum of all the numbers from 1 to n is
            (n*(n+1)/2)<br/>Therefore, sum of all the numbers from 1 to 50 is</p>
        <pre>50*(50+1)/2  (Here, n = 50)  <br/>
      = 50*(51)/2  <br/>
      = 25*51 <br/>
      = 1275.</pre></div>
        <p>Therefore, all we need to do is to sum all the integers present in the file and subtract the sum from 1275.
            The difference between 1275 and this sum would give us the missing integer.</p>
       
    </div>
</article>
        </div>
    )
}

export default Puz40
